import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('./folder/folder.module').then( m => m.FolderPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'request-order',
    loadChildren: () => import('./request-order/request-order.module').then( m => m.RequestOrderPageModule)
  },
  {
    path: 'request-detail',
    loadChildren: () => import('./request-detail/request-detail.module').then( m => m.RequestDetailPageModule)
  },
  {
    path: 'approve-request',
    loadChildren: () => import('./approve-request/approve-request.module').then( m => m.ApproveRequestPageModule)
  },
  {
    path: 'approve-branch-list',
    loadChildren: () => import('./approve-branch-list/approve-branch-list.module').then( m => m.ApproveBranchListPageModule)
  },
  {
    path: 'add-income',
    loadChildren: () => import('./add-income/add-income.module').then( m => m.AddIncomePageModule)
  },
  {
    path: 'add-expense',
    loadChildren: () => import('./add-expense/add-expense.module').then( m => m.AddExpensePageModule)
  },
  {
    path: 'income-list',
    loadChildren: () => import('./income-list/income-list.module').then( m => m.IncomeListPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
